import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };

    const handleClickOutside = (event) => {
      if (!event.target.closest('.dropdown-menu') && !event.target.closest('.menu-button')) {
        setMenuOpen(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('click', handleClickOutside);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <nav
      className={`fixed flex flex-col justify-between w-full h-fit px-4 md:px-12 lg:px-20 py-4 top-0 left-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-primary-olive shadow-lg py-3' : 'bg-transparent bg-gradient-to-b from-black/50 to-transparent py-6'
      }`}
    >
      <div className="relative flex justify-between items-center w-full">
        <button
          className={`menu-button text-lg md:text-xl font-bold tracking-wider z-50 transition-colors ${
            scrolled ? 'text-primary hover:text-white' : 'text-primary-bright hover:text-primary-olive'
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
          style={{ minWidth: '110px', textAlign: 'left' }}
          aria-label="Toggle menu"
        >
          {menuOpen ? 'ZAMKNIJ' : 'MENU'}
        </button>
        
        <div className="absolute left-1/2 transform -translate-x-1/2 w-full text-center pointer-events-none">
          <Link to="/" className="inline-block pointer-events-auto">
            <p
              className={`font-bold tracking-widest ${
                scrolled ? 'text-primary text-2xl md:text-4xl' : 'text-primary-bright text-3xl md:text-5xl drop-shadow-md'
              } transition-all duration-300`}
            >
              CZARNA OWCA
            </p>
          </Link>
        </div>
        
        
      </div>
      
      {/* Dropdown Menu */}
      <div
        className={`dropdown-menu absolute top-full left-0 w-full bg-primary-dark md:bg-transparent md:static flex flex-col md:flex-row justify-start md:justify-center items-center text-primary-bright transition-all duration-300 origin-top overflow-hidden ${
          menuOpen ? 'max-h-96 py-6 opacity-100' : 'max-h-0 py-0 opacity-0 md:opacity-100 md:max-h-screen md:hidden'
        }`}
      >
        <ul className="flex flex-col md:flex-row space-y-6 md:space-y-0 md:space-x-8 text-xl font-medium tracking-wide">
          <li>
            <Link to='/' onClick={() => setMenuOpen(false)} className="hover:text-primary-olive transition-colors">
              STRONA GŁÓWNA
            </Link>
          </li>
          <li>
            <Link to='/kontakt' onClick={() => setMenuOpen(false)} className="hover:text-primary-olive transition-colors">
              KONTAKT
            </Link>
          </li>
          <li>
            <Link to="/galeria" onClick={() => setMenuOpen(false)} className="hover:text-primary-olive transition-colors">
              GALERIA
            </Link>
          </li>
           <li>
            <Link to="/cennik" onClick={() => setMenuOpen(false)} className="hover:text-primary-olive transition-colors">
              CENNIK
            </Link>
          </li>
          <li>
            <Link to="/nasza_historia" onClick={() => setMenuOpen(false)} className="hover:text-primary-olive transition-colors">
              NASZA HISTORIA
            </Link>
          </li>
          
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;